<template>
    <v-card class="ma-2 pa-1">
        <v-card-title>Completed Tasks</v-card-title>
        <div v-if="completed.length > 0">
            <Task v-for="task in completed" :key="task.id" :task="task"/>

        </div>
        <v-card-text v-else>There are no completed tasks.</v-card-text>
    </v-card>
</template>

<script>
    import Task from "../Task";
    import { mapGetters } from 'vuex';

    export default {
        name: "Completed",
        components: {
            Task
        },
        computed: {
            ...mapGetters(['completed'])
        }
    }
</script>

<style scoped>

</style>